interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
  twitterCard?: string;
  schemaData?: Record<string, unknown>[];
}

const BASE_URL = 'https://www.aiyevideo.com';

export default function SEO({ 
  title = '爱液视频官网 - 官方正版视频平台',
  description = '爱液视频官网是您值得信赖的官方视频平台，提供海量正版高清视频内容，极速播放体验，多终端同步观看。立即访问爱液视频官网，畅享优质视频娱乐生活，注册即享专属会员福利。',
  keywords = '爱液视频官网,爱液视频官网入口,爱液视频官方网站,爱液视频在线观看,爱液视频高清播放,爱液视频会员注册,爱液视频最新地址',
  canonicalUrl = BASE_URL,
  ogType = 'website',
  ogImage = 'https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20brand%20visual%20with%20warm%20orange%20and%20teal%20accents%2C%20cinematic%20atmosphere%2C%20clean%20minimalist%20design%2C%20digital%20entertainment%20concept&width=1200&height=630&seq=og-default&orientation=landscape',
  ogTitle = '爱液视频官网 - 官方正版视频平台',
  ogDescription = '海量正版高清视频内容，极速播放体验，多终端同步观看。注册即享专属会员福利！',
  twitterCard = 'summary_large_image',
  schemaData = [],
}: SEOProps) {
  const allSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '爱液视频',
      url: BASE_URL,
      logo: `${BASE_URL}/logo.png`,
      description: '爱液视频是领先的正版高清视频平台，提供海量优质视频内容和极致观影体验。',
      foundingDate: '2018',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '400-888-9999',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '爱液视频',
      url: BASE_URL,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${BASE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: ogTitle,
      description: ogDescription,
      url: canonicalUrl,
      isPartOf: {
        '@type': 'WebSite',
        name: '爱液视频',
        url: BASE_URL,
      },
    },
    ...schemaData,
  ];

  return (
    <script type="application/ld+json">
      {JSON.stringify(allSchemas)}
    </script>
  );
}